import {
  buildDailyChartSession,
  DailyAxisLabelOptions,
  dailyAxisValues,
  DailyChartSession,
  getDailySessionLength,
  getRegularSessionBounds,
  getSessionKindForDateAndTime,
  RegularSessionBounds,
  SessionKind,
} from '../../../../shared_components/utils/charting';
import {
  MARKET_CLOSE_NY_TIME,
  MARKET_DATA_TIME_ZONE,
  MARKET_OPEN_NY_TIME,
} from '../../../constants/date-time.constants';
import { MarketCountryCode } from '../../../models/fundamental/types';
import MarketHoursState from '../../../store-util/MarketHoursState';
import { NullableString } from '../../../util/types';

import {
  DAILY_CHART_LABEL_INTERVAL_MINUTES,
  DAILY_CHART_SESSION_END_NY,
  DAILY_CHART_SESSION_START_NY,
} from './constants';

// Enhanced charts only - the flag-off path runs legacy/dailyChart.legacy. The maths live in
// shared_components/utils/charting; this file binds them to MarketHoursState. ace-web trades US
// symbols only, so every session here is the US one.
export type { DailyChartSession, RegularSessionBounds, SessionKind };
export {
  getDailyChartIndex,
  getDailySessionLength,
  getLatestDateAndTime,
  getOHLCVDateAndTime,
} from '../../../../shared_components/utils/charting';

const REGULAR_SESSION_DEFAULTS = { open: MARKET_OPEN_NY_TIME, close: MARKET_CLOSE_NY_TIME };
const AXIS_LABELS: DailyAxisLabelOptions = {
  labelIntervalMinutes: DAILY_CHART_LABEL_INTERVAL_MINUTES,
  labelEdgeSlots: false,
};

export const getUsDailyChartSession = (): DailyChartSession => {
  const { marketHours } = MarketHoursState.get(MarketCountryCode.UnitedStates);

  return buildDailyChartSession(
    {
      timeZone: marketHours.timeZone,
      start: marketHours.preMarketStart || marketHours.open,
      end: marketHours.afterMarketEnd || marketHours.close,
    },
    { timeZone: MARKET_DATA_TIME_ZONE, start: DAILY_CHART_SESSION_START_NY, end: DAILY_CHART_SESSION_END_NY },
  );
};

export const getUsRegularSessionBounds = (dateAndTime?: NullableString): RegularSessionBounds => {
  const { marketHours, nonWorkingDays } = MarketHoursState.get(MarketCountryCode.UnitedStates);

  return getRegularSessionBounds(getUsDailyChartSession(), marketHours, {
    nonWorkingDays,
    dateAndTime,
    defaults: REGULAR_SESSION_DEFAULTS,
  });
};

export const getUsSessionKind = (dateAndTime: NullableString): SessionKind | null => {
  const { marketHours, nonWorkingDays } = MarketHoursState.get(MarketCountryCode.UnitedStates);

  return getSessionKindForDateAndTime(dateAndTime, getUsDailyChartSession(), {
    marketHours,
    nonWorkingDays,
    defaults: REGULAR_SESSION_DEFAULTS,
  });
};

export const usDailyAxisValues = (session: DailyChartSession): string[] => dailyAxisValues(session, AXIS_LABELS);

export const getDailyMaxDomainUsStocks = (): number => getDailySessionLength(getUsDailyChartSession());
